export const ru = {
    'show-more': 'Показать ещё',
    trips: 'Заявки',
};
